/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  SelectController,
  CustomSortController,
  ChoiceBoxController,
  RangeController,
  ToggleSwitchController,
} from '../../../controllers/Base';

const GeneralControllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
}) => (
  <>
    <ControllersGroup
      title="Opções Gerais"
      id="general"
      key="general"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={config?.SortValuesControl === 'Customizado' ? data?.index?.length : 0}
    >
      <SelectController
        label="Ordenar colunas"
        handle={handle}
        kWord="SortValuesControl"
        options={[
          { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
          { label: 'Alfabética A-Z', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
          { label: 'Alfabética Z-A', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
          { label: 'Customizado', value: 'Customizado', id: 'Customizado' },
        ]}
        configValue={config?.SortValuesControl}
        fullWidth
      />
      {config?.SortValuesControl === 'Customizado' && (
        <CustomSortController
          handle={handle}
          kWord="CustomSortControlUpt"
          oldOrder={data?.columns || []}
          newOrder={config?.CustomSortControl?.kpiCategories || []}
        />
      )}
      <SelectController
        label="Ordenar campos"
        handle={handle}
        kWord="SortDataControl"
        options={[
          { label: 'Não ordenado', value: 'Não ordenado', id: 'nao-ordenado' },
          { label: 'Crescente', value: 'Crescente', id: 'Crescente' },
          { label: 'Decrescente', value: 'Decrescente', id: 'Decrescente' },
        ]}
        configValue={config?.SortDataControl}
        fullWidth
      />
      {config?.SortDataControl !== 'Não ordenado' && (
        <SelectController
          label="Coluna a ser ordenada"
          handle={handle}
          kWord="ColumnToSortControl"
          options={data?.columns?.map((col) => (
            { label: col, value: col.toString(), id: `sort-${col}` }
          ))}
          configValue={(config?.ColumnToSortControl === '' ? data?.columns?.[0] : config.ColumnToSortControl) ?? ''}
          fullWidth
        />
      )}
      <ChoiceBoxController
        label="Tamanho das colunas"
        handle={handle}
        kWord="ColumnSize"
        options={[
          { value: 'auto', label: 'Auto', id: 'auto' },
          { value: 'fixed', label: 'Fixo', id: 'fixed' },
        ]}
        configValue={config?.ColumnSize || 'auto'}
        fullWidth
      />
      {config?.ColumnSize === 'fixed' && (
        <>
          <RangeController
            label="Tamanho"
            handle={handle}
            kWord="ColumnWidth"
            configValue={config?.ColumnWidth ?? 50}
            min={1}
            max={1000}
            fullWidth
          />
          <ToggleSwitchController
            label="Texto corrido"
            handle={handle}
            kWord="RunningText"
            configValue={config?.RunningText}
            firstOption=""
            secondOption=""
            fullWidth
          />
        </>
      )}
    </ControllersGroup>
  </>
);

GeneralControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
};

export default GeneralControllers;
